module.exports = __webpack_public_path__ + "media/public/images/about/experts/russian_museum-61637cc12a427c9753f11e50b7efe82e.svg";